import TripPriceLoader, {
    type TripPriceLoaderFactory,
} from '../TripPriceLoader';
import { type PriceObject } from '@search/ItineraryPriceLoader';
import { GetMinPricesApiApiGetMinPricesGet } from '@clients/BusApi';

export default class BusPriceLoader extends TripPriceLoader {
    specificProviderId: number | null;

    constructor({
        specificProviderId,
        ...other
    }: Omit<TripPriceLoaderFactory, 'priceTypeCode'> & {
        specificProviderId: number | null;
    }) {
        super(other);
        this.specificProviderId = specificProviderId;
    }

    override async fetchSinglePrices(
        fromDate: Date,
        toDate: Date,
        origin: string,
        destination: string
    ): Promise<PriceObject[]> {
        const { data } = await GetMinPricesApiApiGetMinPricesGet({
            from: +origin,
            to: +destination,
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
            capacity: this.adultCount + this.childCount,
            providerId: this.specificProviderId ?? undefined,
        });
        return Object.keys(data).reduce(
            (previousValue, key) => [
                ...previousValue,
                {
                    value: data[key] === '-' ? '-' : +data[key],
                    date: key,
                },
            ],
            [] as PriceObject[]
        );
    }

    override equals(other: BusPriceLoader): boolean {
        return (
            super.equals(other) &&
            other.specificProviderId === this.specificProviderId
        );
    }
}
